// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffcommon/v1/feature_flag_service.proto (package bffcommon.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ListFeatureFlagsRequestSchema, ListFeatureFlagsResponseSchema } from "../../featureflag/v1/feature_flag_pb";
import { file_featureflag_v1_feature_flag } from "../../featureflag/v1/feature_flag_pb";

/**
 * Describes the file bffcommon/v1/feature_flag_service.proto.
 */
export const file_bffcommon_v1_feature_flag_service: GenFile = /*@__PURE__*/
  fileDesc("CidiZmZjb21tb24vdjEvZmVhdHVyZV9mbGFnX3NlcnZpY2UucHJvdG8SDGJmZmNvbW1vbi52MTJ7ChJGZWF0dXJlRmxhZ1NlcnZpY2USZQoQTGlzdEZlYXR1cmVGbGFncxInLmZlYXR1cmVmbGFnLnYxLkxpc3RGZWF0dXJlRmxhZ3NSZXF1ZXN0GiguZmVhdHVyZWZsYWcudjEuTGlzdEZlYXR1cmVGbGFnc1Jlc3BvbnNlQsgBChBjb20uYmZmY29tbW9uLnYxQhdGZWF0dXJlRmxhZ1NlcnZpY2VQcm90b1ABWkpnaXRodWIuY29tL2VuZWNoYWluL2Vwb3NpdGlvbi1hcHAvYmFja2VuZC9nZW4vcHJvdG8vYmZmY29tbW9uL3YxO2JmZmNvbW1vbqICA0JYWKoCDEJmZmNvbW1vbi5WMcoCDEJmZmNvbW1vblxWMeICGEJmZmNvbW1vblxWMVxHUEJNZXRhZGF0YeoCDUJmZmNvbW1vbjo6VjFiBnByb3RvMw", [file_featureflag_v1_feature_flag]);

/**
 * @generated from service bffcommon.v1.FeatureFlagService
 */
export const FeatureFlagService: GenService<{
  /**
   * @generated from rpc bffcommon.v1.FeatureFlagService.ListFeatureFlags
   */
  listFeatureFlags: {
    methodKind: "unary";
    input: typeof ListFeatureFlagsRequestSchema;
    output: typeof ListFeatureFlagsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffcommon_v1_feature_flag_service, 0);

